const o = {
  name: "BookOpen",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.65847 3.53007C4.31559 2.20115 8.32186 2.16114 12 3.41005C15.6781 2.16114 19.6844 2.20115 23.3415 3.53007L24 3.76935V21.8973L22.6585 21.4098C19.3291 20.2 15.6709 20.2 12.3415 21.4098L12 21.5339L11.6585 21.4098C8.3291 20.2 4.6709 20.2 1.34153 21.4098L0 21.8973V3.76935L0.65847 3.53007ZM2 19.1043C4.94454 18.3018 8.05546 18.3018 11 19.1043V5.18759C8.07192 4.27406 4.92808 4.27406 2 5.18759V19.1043ZM13 19.1043C15.9445 18.3018 19.0555 18.3018 22 19.1043V5.18759C19.0719 4.27406 15.9281 4.27406 13 5.18759V19.1043Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as BookOpen
};
